export const eventCreationSteps = [
    { id: 'basics', title: 'Basic Details' },
    { id: 'requirements', title: 'Requirements & Limits' },
    { id: 'groups', title: 'Run Groups' },
    { id: 'registration', title: 'Registration Settings' },
    { id: 'schedule', title: 'Schedule' },
    { id: 'documents', title: 'Documents & Rules' },
    { id: 'review', title: 'Review & Publish' }
  ];